export default "__VITE_ASSET__CgG6tVpg__"